'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var defer = require('promise-defer');

var AsyncPriorityQueue = function AsyncPriorityQueue() {
  var config = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var _Object$assign = _extends({ debug: false, maxParallel: 6, processingFrequency: 30 }, config);

  var debug = _Object$assign.debug;
  var maxParallel = _Object$assign.maxParallel;
  var processingFrequency = _Object$assign.processingFrequency;

  var q = { low: [], mid: [], high: [] },
      activeTaskCount = 0,
      interval = undefined;
  debug && console.log('instantiating AsyncPriorityQueue with max parallelism of ' + maxParallel + ' and processingFrequency of ' + processingFrequency + ' ms');

  var decrementActiveTaskCount = function decrementActiveTaskCount() {
    debug && console.log('finished a task');
    activeTaskCount -= 1;
  };

  return {
    start: function start() {
      interval = setInterval(this.processQueue, processingFrequency);
    },
    stop: function stop() {
      interval && clearInterval(interval);
    },
    clear: function clear(priority) {
      q[priority] = [];
    },
    enqueue: function enqueue(task) {
      q[task.priority] && q[task.priority].unshift(task) || console.error('Invalid priority: ' + task.priority + '. Please use \'low\' \'mid\' or \'high\'');
    },
    processQueue: function processQueue() {
      debug && console.log('processing task queue');
      debug && console.log('active task count:', activeTaskCount);
      if (activeTaskCount < maxParallel) {
        debug && console.log('high: ' + q.high.length + ', mid: ' + q.mid.length + ', low: ' + q.low.length);

        var activeTask = q.high.length > 0 ? q.high.pop() : q.mid.length > 0 ? q.mid.pop() : q.low.pop();
        if (activeTask) {
          debug && console.log('executing new task');
          activeTaskCount += 1;
          activeTask.execute().then(decrementActiveTaskCount, decrementActiveTaskCount);
        }
      }
    }
  };
};

var AsyncTask = function AsyncTask() {
  var config = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var _Object$assign2 = _extends({ priority: 'mid' }, config);

  var priority = _Object$assign2.priority;
  var callback = _Object$assign2.callback;

  var deferred = defer();
  return {
    priority: priority,
    promise: deferred.promise,
    execute: function execute() {
      return callback().then(function (data) {
        return deferred.resolve(data);
      }, function (data) {
        return deferred.reject(data);
      });
    }
  };
};

module.exports = { AsyncPriorityQueue: AsyncPriorityQueue, AsyncTask: AsyncTask };



//////////////////
// WEBPACK FOOTER
// ./node_modules/async-priority-queue/dist/async_priority_queue.js
// module id = 47
// module chunks = 0